module.exports = "<div\r\n    class=\"tmoProcessNode tmoProcessNode-container\"\r\n    ng-class=\"{'tmoProcessNode-containerCompleted': $ctrl.isStepCompleted}\">\r\n    <!-- Tick -->\r\n    <i ng-if=\"$ctrl.isStepCompleted\" class=\"iconww-Tick tmoProcessNode-tick\"></i>\r\n\r\n    <!-- Label -->\r\n    <span>\r\n        {{$ctrl.label}}\r\n        <span class=\"sr-only\">{{$ctrl.isStepCompleted ? 'completed' : 'pending'}}</span>\r\n    </span>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shop/trackmyorder/track-my-order-process-node.component.html
// module id = 303
// module chunks = 0 2